<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">Статистика</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12 lg12 md12>

        <p class="title">Статистика по категориям товаров</p>
        <v-layout class="elevation-1 white mb-4 pa-3 column">
          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="productCategoryStatisticsStartDateMenu"
                    :close-on-content-click="false"
                    v-model="productCategoryStatistics.startDateMenu"
                    :return-value.sync="productCategoryStatistics.startDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="productCategoryStatistics.startDateFormatted"
                      label="Начальная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="productCategoryStatistics.startDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="productCategoryStatisticsEndDateMenu"
                    :close-on-content-click="false"
                    v-model="productCategoryStatistics.endDateMenu"
                    :return-value.sync="productCategoryStatistics.endDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="productCategoryStatistics.endDateFormatted"
                      label="Конечная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="productCategoryStatistics.endDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-select
                    :items="groupList"
                    label="Группировка"
                    outline
                    v-model="productCategoryStatistics.group"
                    @input="getProductCategoryChartData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs12 lg12 md12>
                <v-select
                    v-model="productCategoryStatistics.distributionChannelIdList"
                    :items="distributionChannelList"
                    item-text="title"
                    item-value="id"
                    chips
                    label="Каналы продаж"
                    multiple
                    outline
                    @input="getProductCategoryChartData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout row>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    :items="[]"
                    v-model="productCategoryStatistics.branchesSelected"
                    label="Филиалы"
                    chips
                    outline
                    multiple
                    readonly
                    @click="productCategoryStatistics.branchesDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        @click="productCategoryStatistics.branchesDialog = true"
                    >
                      <strong>{{ data.item }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout row>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    :items="[]"
                    v-model="productCategoryStatistics.brandsSelected"
                    label="Бренды"
                    chips
                    outline
                    multiple
                    readonly
                    @click="productCategoryStatistics.brandsDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        @click="productCategoryStatistics.brandsDialog = true"
                    >
                      <strong>{{ data.item }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12 class="mt-3">
            <v-layout>
              <v-flex xs12 lg12 md12>
                <line-chart :data="productCategoryStatistics.chartData" :library="chartOptions"></line-chart>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-dialog
              v-model="productCategoryStatistics.branchesDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Филиалы</v-card-title>
              <v-layout row>
                <v-flex xs12 lg12 md12 class="ml-2">
                  <div
                      v-for="(branch, index) in productCategoryStatistics.branches"
                      :key="branch.id"
                  >
                    <v-checkbox
                        :label="branch.title"
                        class="ma-0 pa-0"
                        v-model="productCategoryStatistics.branches[index].checked"
                        @change="onBranchInput"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="productCategoryStatistics.branchesDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
              v-model="productCategoryStatistics.brandsDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Бренды</v-card-title>
              <v-layout row>
                <v-flex xs12 lg12 md12 class="ml-2">
                  <div
                      v-for="(brand, index) in productCategoryStatistics.brands"
                      :key="brand.id"
                  >
                    <v-checkbox
                        :label="brand.title"
                        class="ma-0 pa-0"
                        v-model="productCategoryStatistics.brands[index].checked"
                        @change="onBrandInput"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="productCategoryStatistics.brandsDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-layout>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Статистика'}
        ],
        pageDataReady: {
          isReady: false
        },
        groupList: [{text: 'День', value: 'day'}, {text: 'Неделя', value: 'week'}, {text: 'Месяц', value: 'month'}],
        channelList: [],
        productTreeIdCounter: 0,
        productCategoryStatistics: {
          startDate: null,
          startDateFormatted: null,
          startDateMenu: false,
          endDate: null,
          endDateFormatted: null,
          endDateMenu: false,
          group: 'day',
          distributionChannelIdList: [],
          productDialog: false,
          productTreeData: [],
          productItems: [],
          chartData: [],
          branches: [],
          branchesSelected: [],
          branchesDialog: false,
          brands: [],
          brandsSelected: [],
          brandsDialog: false
        },
        chartOptions: {
          tooltips: {
            mode: 'index',
            displayColors: true,
            callbacks: {
              label: function (tooltipItem) {
                let val = tooltipItem.yLabel
                val = Math.round(parseFloat(val)).toString()
                let result = ''
                let i = 0
                val.split('').reverse().forEach(function (char) {
                  if (i === 3) {
                    result += ' '
                    i = 1
                  } else {
                    i++
                  }
                  result += char
                })
                result = result.split('').reverse().join('')
                return result + ' ₽'
              }
            }
          }
        }
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
    },
    created () {
      this.pageDataStatus()
      this.$store.commit('setPageTitle', 'Статистика по категориям товаров')
      this.$store.dispatch('getDistributionChannelList')

      let date = new Date()
      this.productCategoryStatistics.endDate = this.$moment(date).format('YYYY-MM-DD')
      date.setDate(date.getDate() - 30)
      this.productCategoryStatistics.startDate = this.$moment(date).format('YYYY-MM-DD')
      this.productCategoryStatistics.startDateFormatted = this.formatDate(this.productCategoryStatistics.startDate)
      this.productCategoryStatistics.endDateFormatted = this.formatDate(this.productCategoryStatistics.endDate)
      this.getProductCategoryChartData()

      this.$store.dispatch('getBranchList')
      this.$store.dispatch('getBrandList')
    },
    computed: {
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      productCategoryChartData () {
        return this.$store.getters.productCategoryChartData
      },
      productCategoryStatisticsProductDialog () {
        return this.productCategoryStatistics.productDialog
      },
      branchList () {
        return this.$store.getters.branchList
      },
      brandList () {
        return this.$store.getters.brandList
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      pageDataStatus () {
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      getProductCategoryChartData () {
        let filtersData = {
          start_date: this.productCategoryStatistics.startDate,
          end_date: this.productCategoryStatistics.endDate,
          group: this.productCategoryStatistics.group
        }

        if (this.productCategoryStatistics.distributionChannelIdList.length > 0) {
          filtersData.distribution_channel_id_list = this.productCategoryStatistics.distributionChannelIdList
        }

        let branchIdList = []
        for (let i = 0; i < this.productCategoryStatistics.branches.length; i++) {
          if (this.productCategoryStatistics.branches[i].checked) {
            branchIdList.push(this.productCategoryStatistics.branches[i].id)
          }
        }
        if (branchIdList.length > 0) {
          filtersData.branch_id_list = branchIdList
        }

        let brandIdList = []
        for (let i = 0; i < this.productCategoryStatistics.brands.length; i++) {
          if (this.productCategoryStatistics.brands[i].checked) {
            brandIdList.push(this.productCategoryStatistics.brands[i].id)
          }
        }
        if (brandIdList.length > 0) {
          filtersData.brand_id_list = brandIdList
        }

        this.$store.dispatch('productCategoryChartData', filtersData)
      },
      onInputStartDate () {
        this.$refs.productCategoryStatisticsStartDateMenu.save(this.productCategoryStatistics.startDate)
        this.productCategoryStatistics.startDateFormatted = this.formatDate(this.productCategoryStatistics.startDate)
        this.getProductCategoryChartData()
      },
      onInputEndDate () {
        this.$refs.productCategoryStatisticsEndDateMenu.save(this.productCategoryStatistics.endDate)
        this.productCategoryStatistics.endDateFormatted = this.formatDate(this.productCategoryStatistics.endDate)
        this.getProductCategoryChartData()
      },
      onBranchInput () {
        this.productCategoryStatistics.branchesSelected = []
        for (let i = 0; i < this.productCategoryStatistics.branches.length; i++) {
          if (this.productCategoryStatistics.branches[i].checked) {
            this.productCategoryStatistics.branchesSelected.push(this.productCategoryStatistics.branches[i].title)
          }
        }
        this.getProductCategoryChartData()
      },
      onBrandInput () {
        this.productCategoryStatistics.brandsSelected = []
        for (let i = 0; i < this.productCategoryStatistics.brands.length; i++) {
          if (this.productCategoryStatistics.brands[i].checked) {
            this.productCategoryStatistics.brandsSelected.push(this.productCategoryStatistics.brands[i].title)
          }
        }
        this.getProductCategoryChartData()
      }
    },
    watch: {
      productCategoryChartData (val) {
        this.productCategoryStatistics.chartData = []
        for (let k = 0; k < this.productCategoryChartData.length; k++) {
          let index = this.productCategoryStatistics.chartData.length
          this.productCategoryStatistics.chartData[index] = {data: {}, name: this.productCategoryChartData[k].title}
          for (let i = 0; i < this.productCategoryChartData[k].chart_series_value_list.length; i++) {
            this.productCategoryStatistics.chartData[index].data[this.productCategoryChartData[k].chart_series_value_list[i].date] = this.productCategoryChartData[k].chart_series_value_list[i].value
          }
        }
      },
      productCategoryStatisticsProductDialog (val) {
        if (!this.productCategoryStatistics.productDialog) {
          this.getProductCategoryChartData()
        }
      },
      branchList (val) {
        this.productCategoryStatistics.branches = this.branchList
      },
      brandList (val) {
        this.productCategoryStatistics.brands = this.brandList
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Statistics/StatisticsProductCategory.vue